import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { AlertService, UserService } from "@app/_services";
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { EmployeeAcqPayment } from "../employee-acq-payment";
import { EmployeeAcqPaymentService } from "../employee-acq-payment.service";
import { PropertyProfileService } from "@app/_components/property-profile/property-profile.service";
import { RealtorProfileService } from "@app/_components/realtor-profile/realtor-profile.service";
import { EmployeeProfileService } from "@app/_components/employee-profile/employee-profile.service";
import { PercentageValuesPositive } from "@app/_helpers";
import { first } from "rxjs";
import { RealtorProfileComponent } from "@app/_components/realtor-profile/realtor-profile/realtor-profile.component";
import { DialogService } from "primeng/dynamicdialog";
import { PropertyProfileComponent } from "@app/_components/property-profile/property-profile/property-profile.component";
import { EmployeeProfileComponent } from "@app/_components/employee-profile/employee-profile/employee-profile.component";

@Component({
    selector: "app-employee-acq-payment",
    templateUrl: "./employee-acq-payment.component.html",
    styleUrls: ["./employee-acq-payment.component.css"],
    providers: [DialogService, MessageService, ConfirmationService],
    standalone: false
})
export class EmployeeAcqPaymentComponent implements OnInit {
  employeeProfilesList: any;
  percentageValuesPositive: any = PercentageValuesPositive;
  realtorProfile: any;
  propertyProfile: any;
  AcqAgent1PaymentAmt: number;
  AcqAgent2PaymentAmt: number;
  RetAgent1PaymentAmt: number;
  RetAgent2PaymentAmt: number;
  isAgent1 = false;
  isAgent2 = false;
  realtorProfile2: any;

  constructor(
    private primengConfig: PrimeNGConfig,
    private employeeAcqPaymentService: EmployeeAcqPaymentService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private propertyProfileService: PropertyProfileService,
    private realtorProfileService: RealtorProfileService,
    private employeeProfileService: EmployeeProfileService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
		private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title),
      (this.employeeAcqPayment = data.employeeAcqPayment),
      (this.statuses = employeeAcqPaymentService.statuses);
  }

  @Input() employeeAcqPayment: EmployeeAcqPayment;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  employeeAcqPaymentId: number;
  taskUserSuggestions: string[];
  propertyProfiles: any[]=[];
  realtorProperties: any[]=[];

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  positiveIntegerMsg = {
    type: "pattern",
    message:
      "Invalid input. Please enter positive non zero integers only.",
  };

  onlyNumberMsg = {
    type: "pattern",
    message:
      "Invalid input. Only numbers allowed.",
  };

  validationMessages = {
    employeeAcqPaymentId: [],
    propertyProfileId: [{ type: 'required', message: 'Required' }],
    realtorProfileId: [],
    realtorProfileId2: [],
    propertyProfileName: [],
    estGrossRev: [],
    compAcqAgent1Pct: [],
    compAcqAgent1SplitPct: [],
    compAcqAgent1Amt: [],
    compAcqAgent1Desc: [],
    compAcqAgent2Pct: [],
    compAcqAgent2SplitPct: [],
    compAcqAgent2Amt: [],
    compAcqAgent2Desc: [],

    compAcqAgent1PayDate1: [],
    compAcqAgent1PayDate1Amount: [],
    compAcqAgent1PayDate1Status: [],

    compAcqAgent1PayDate2: [],
    compAcqAgent1PayDate2Amount: [],
    compAcqAgent1PayDate2Status: [],

    compAcqAgent2PayDate1: [],
    compAcqAgent2PayDate1Amount: [],
    compAcqAgent2PayDate1Status: [],

    compAcqAgent2PayDate2: [],
    compAcqAgent2PayDate2Amount: [],
    compAcqAgent2PayDate2Status: [],

    compRetAgent1PayDate1: [],
    compRetAgent1PayDate1Amount: [],
    compRetAgent1PayDate1Status: [],

    compRetAgent2PayDate1: [],
    compRetAgent2PayDate1Amount: [],
    compRetAgent2PayDate1Status: [],

    actGrossRevYr1: [],
    compRetAgent1Pct: [],
    compRetAgent1SplitPct: [],
    compRetAgent1Amt: [],
    compRetAgent1Desc: [],
    compRetAgent2Pct: [],
    compRetAgent2SplitPct: [],
    compRetAgent2Amt: [],
    compRetAgent2Desc: [],
    opsNote: [],
    agnt1: [{ type: 'required', message: 'Required' }],
    agnt2: [],
  };

  ngOnInit() {
    this.fetchEmployeeProfiles();
    this.fetchRealtor();
    this.fetchPropertyProfiles();
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole employeeAcqPayment object
    if (this.employeeAcqPayment) {
      this.employeeAcqPaymentId = this.employeeAcqPayment.employeeAcqPaymentId;
      if(this.employeeAcqPayment.agnt1 != undefined){
        if(this.employeeAcqPayment.agnt1.firstName != null){
          if(this.employeeAcqPayment.agnt1.lastName != null){
            this.employeeAcqPayment.agnt1.summary = this.employeeAcqPayment?.agnt1?.firstName +" "+this.employeeAcqPayment?.agnt1?.lastName;
          }else{
            this.employeeAcqPayment.agnt1.summary = this.employeeAcqPayment?.agnt1?.firstName;
          }
        }
      }
      if(this.employeeAcqPayment.agnt2 != undefined){
        if(this.employeeAcqPayment?.agnt2?.firstName != null){
          if(this.employeeAcqPayment?.agnt2?.lastName != null){
            this.employeeAcqPayment.agnt2.summary = this.employeeAcqPayment?.agnt2?.firstName +" "+this.employeeAcqPayment?.agnt2?.lastName;
          }else{
            this.employeeAcqPayment.agnt2.summary = this.employeeAcqPayment?.agnt2?.firstName;
          }
        }
      }
     
      if(this.employeeAcqPayment.compAcqAgent1PayDate1 != undefined && this.employeeAcqPayment.compAcqAgent1PayDate1 != null){
				this.employeeAcqPayment.compAcqAgent1PayDate1 = moment.utc(this.employeeAcqPayment.compAcqAgent1PayDate1).toDate();
			}
      if(this.employeeAcqPayment.compAcqAgent1PayDate2 != undefined && this.employeeAcqPayment.compAcqAgent1PayDate2 != null){
				this.employeeAcqPayment.compAcqAgent1PayDate2 = moment.utc(this.employeeAcqPayment.compAcqAgent1PayDate2).toDate();
			}
      if(this.employeeAcqPayment.compAcqAgent2PayDate1 != undefined && this.employeeAcqPayment.compAcqAgent2PayDate1 != null){
				this.employeeAcqPayment.compAcqAgent2PayDate1 = moment.utc(this.employeeAcqPayment.compAcqAgent2PayDate1).toDate();
			}
      if(this.employeeAcqPayment.compAcqAgent2PayDate2 != undefined && this.employeeAcqPayment.compAcqAgent2PayDate2 != null){
				this.employeeAcqPayment.compAcqAgent2PayDate2 = moment.utc(this.employeeAcqPayment.compAcqAgent2PayDate2).toDate();
			}
      if(this.employeeAcqPayment.compRetAgent1PayDate1 != undefined && this.employeeAcqPayment.compRetAgent1PayDate1 != null){
				this.employeeAcqPayment.compRetAgent1PayDate1 = moment.utc(this.employeeAcqPayment.compRetAgent1PayDate1).toDate();
			}
      if(this.employeeAcqPayment.compRetAgent2PayDate1 != undefined && this.employeeAcqPayment.compRetAgent2PayDate1 != null){
				this.employeeAcqPayment.compRetAgent2PayDate1 = moment.utc(this.employeeAcqPayment.compRetAgent2PayDate1).toDate();
			}
      
      this.fixDates();
      this.form1.patchValue(this.employeeAcqPayment);      
    }
  }

  /* On each keystroke search for the user */
	onKeyInput(event)
	{
		let query = event.query;
		this.findUsersWith(query);
		return this.taskUserSuggestions;
	}

	/* Search for user */
	findUsersWith(queryString: string)
	{
		this.userService.findUsersWithEmployeeRelationship(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.taskUserSuggestions = [];
        this.isAgent1 = false;
				this.taskUserSuggestions = data.data.userSummaryList;
        if(this.taskUserSuggestions.length < 1){
          this.isAgent1 = true;
        }
				// console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

  /* On each keystroke search for the user */
	onKeyInput1(event)
	{
		let query = event.query;
		this.findUsersWith1(query);
		return this.taskUserSuggestions;
	}

	/* Search for user */
	findUsersWith1(queryString: string)
	{
		this.userService.findUsersWithEmployeeRelationship(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.taskUserSuggestions = [];
        this.isAgent2 = false;
				this.taskUserSuggestions = data.data.userSummaryList;
        if(this.taskUserSuggestions.length < 1){
          this.isAgent2 = true;
        }
				// console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " +
        this.employeeAcqPaymentId +
        "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.form1.value.compAcqAgent1Amt = null;
      this.form1.value.compAcqAgent2Amt = null;
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.employeeAcqPaymentService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.employeeAcqPayment = res.data.employeeAcqPayment;
          this.doAdd.emit(this.employeeAcqPayment);
        },
        (err: any) => {
          console.log("employeeAcqPayment-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("employeeAcqPayment: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.form1.value.compAcqAgent1Amt = null;
      this.form1.value.compAcqAgent2Amt = null;
      this.formLoading = true;

      this.employeeAcqPaymentService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.employeeAcqPayment = res.data.employeeAcqPayment;
          this.doUpdate.emit(this.employeeAcqPayment);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.employeeAcqPaymentService
        .delete(this.employeeAcqPayment.employeeAcqPaymentId)
        .subscribe(
          (res: any) => {
            console.log(
              "employeeAcqPayment-delete SUCCESS: " + JSON.stringify(res)
            );
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.employeeAcqPayment);
          },
          (err: any) => {
            console.log("employeeAcqPayment-add FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      employeeAcqPaymentId: [this.employeeAcqPaymentId],
      propertyProfileId: ['',Validators.required],
      realtorProfileId: [],
      realtorProfileId2: [],
      propertyProfileName: [],
      estGrossRev: [],
      compAcqAgent1Pct: [],
      compAcqAgent1SplitPct: [],
      compAcqAgent1Amt: [],
      compAcqAgent1Desc: [],
      compAcqAgent2Pct: [],
      compAcqAgent2SplitPct: [],
      compAcqAgent2Amt: [],
      compAcqAgent2Desc: [],

      compAcqAgent1PayDate1: [],
      compAcqAgent1PayDate1Amount: [],
      compAcqAgent1PayDate1Status: [],

      compAcqAgent1PayDate2: [],
      compAcqAgent1PayDate2Amount: [],
      compAcqAgent1PayDate2Status: [],

      compAcqAgent2PayDate1: [],
      compAcqAgent2PayDate1Amount: [],
      compAcqAgent2PayDate1Status: [],

      compAcqAgent2PayDate2: [],
      compAcqAgent2PayDate2Amount: [],
      compAcqAgent2PayDate2Status: [],

      compRetAgent1PayDate1: [],
      compRetAgent1PayDate1Amount: [],
      compRetAgent1PayDate1Status: [],

      compRetAgent2PayDate1: [],
      compRetAgent2PayDate1Amount: [],
      compRetAgent2PayDate1Status: [],

      actGrossRevYr1: [],
      compRetAgent1Pct: [],
      compRetAgent1SplitPct: [],
      compRetAgent1Amt: [],
      compRetAgent1Desc: [],
      compRetAgent2Pct: [],
      compRetAgent2SplitPct: [],
      compRetAgent2Amt: [],
      compRetAgent2Desc: [],
      opsNote: [],
      agnt1: ['',Validators.required],
      agnt2: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    
  }

  fetchPropertyProfiles(){
		try {
			this.propertyProfileService.findAllForRequiredFields()
				.subscribe(
					res => {
						 console.log('findAllPropertyProfile: ' + JSON.stringify(res));
						this.propertyProfiles = res.data.propertyProfiles;
            this.propertyProfiles.forEach(propertyProfile=> {
              if(propertyProfile.propertyProfileId == this.employeeAcqPayment.propertyProfileId){
                this.propertyProfile = propertyProfile;
                this.AcqAgent1PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compAcqAgent1Pct != null? this.employeeAcqPayment?.compAcqAgent1Pct : 0) * (this.employeeAcqPayment?.compAcqAgent1SplitPct != null? this.employeeAcqPayment?.compAcqAgent1SplitPct : 0);
                this.AcqAgent2PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compAcqAgent2Pct != null? this.employeeAcqPayment?.compAcqAgent2Pct : 0) * (this.employeeAcqPayment?.compAcqAgent2SplitPct != null? this.employeeAcqPayment?.compAcqAgent2SplitPct : 0);
                this.RetAgent1PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compRetAgent1Pct != null? this.employeeAcqPayment?.compRetAgent1Pct : 0) * (this.employeeAcqPayment?.compRetAgent1SplitPct != null? this.employeeAcqPayment?.compRetAgent1SplitPct : 0);
                this.RetAgent2PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compRetAgent2Pct != null? this.employeeAcqPayment?.compRetAgent2Pct : 0) * (this.employeeAcqPayment?.compRetAgent2SplitPct != null? this.employeeAcqPayment?.compRetAgent2SplitPct : 0);
                this.form1.patchValue({
                  compAcqAgent1Amt : this.AcqAgent1PaymentAmt,
                  compAcqAgent2Amt : this.AcqAgent2PaymentAmt,
                  compRetAgent1Amt : this.RetAgent1PaymentAmt,
                  compRetAgent2Amt : this.RetAgent2PaymentAmt,
                  compRetAgent1PayDate1Amount : this.RetAgent1PaymentAmt,
                  compRetAgent2PayDate1Amount : this.RetAgent2PaymentAmt,
                });
              }
            });
						return this.propertyProfiles;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));  
			this.alertService.error(error);
		}
	}

  fetchRealtor() {
		try {
			this.realtorProfileService.findAllForRequiredFields().subscribe(
				(res) => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.realtorProperties = res.data.realtorProfiles;
					if (this.realtorProperties.length > 0) {
						this.realtorProperties.forEach(realtorProperty => {
							if (realtorProperty.realtorProfileId == this.employeeAcqPayment?.realtorProfileId) {
								this.realtorProfile = realtorProperty;
							}
              if (realtorProperty.realtorProfileId == this.employeeAcqPayment?.realtorProfileId2) {
								this.realtorProfile2 = realtorProperty;
							}
							//set custom option label
              if(realtorProperty.firstName != null && realtorProperty.lastName != null){
                realtorProperty.displayLabel = realtorProperty.lastName + " " + realtorProperty.firstName;
              } else if(realtorProperty.firstName != null){
                realtorProperty.displayLabel = realtorProperty.firstName;
              } else if(realtorProperty.lastName != null){
                realtorProperty.displayLabel = realtorProperty.lastName;
              }
						});
					}
					return this.realtorProperties;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { }
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
   // get all realtor profiles
	fetchEmployeeProfiles(){
		try {
			this.employeeProfileService.findAllForRequiredFields()
				.subscribe(
					res => {
						 console.log('findAllEmployeeProfilesList: ' + JSON.stringify(res));
						this.employeeProfilesList = res.data.employeeProfiles;
						return this.employeeProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  formAddPropertyProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add PropertyProfile",
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			PropertyProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);
			this.propertyProfiles = [];
			this.fetchPropertyProfiles();
			this.form1.patchValue({
				propertyProfileId : data.propertyProfileId

			});
			

			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			//	this.updateOwnerStmtCB(data);

			// close the dialogBox
			dialogRef.close();
		});
	}

  
	formAddRealtorProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			// realtorProfile: this.realtorProfile,
			title: "Add RealtorProfile",
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		dialogRef.componentInstance.doAddRealtor.subscribe((data) => {
			console.log("Dialog output:", data);

			this.realtorProperties = [];
			this.fetchRealtor();
			this.form1.patchValue({
				realtorProfileId : data.realtorProfileId

			});

			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			//	this.updateOwnerStmtCB(data);

			// close the dialogBox
			dialogRef.close();
		});
	}

  /*********
		* Edit Realtor Profile
		*
		*/
	formEditRealtorProfile(realtorProfile: any) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			realtorProfile: realtorProfile,
			title: 'Edit Realtor Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealtorProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);

				this.realtorProperties = [];
				this.fetchRealtor();
				this.form1.patchValue({
					realtorProfileId: data.realtorProfileId

				});

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

  /*********
		* Edit Property Profile
		*
		*/
	formEditPropertyProfiles() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyProfile: this.propertyProfile,
			title: 'Property Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);
				this.propertyProfiles = [];
				this.fetchPropertyProfiles();
				this.form1.patchValue({
					propertyProfileId: data.propertyProfileId

				});

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}


  updateAmount(event: any, fieldName: any){
    if(fieldName === "estgrossrev"){
      var estGrossRevAmount = event.target.value.replace('$', '');
      var estGrossRevAmount = estGrossRevAmount.replace('.00', '');
      var estGrossRevAmount = estGrossRevAmount.replaceAll(',', '');
      this.employeeAcqPayment.estGrossRev = Number(estGrossRevAmount);
    }
    if(fieldName === "acqagent1pct"){ 
      this.employeeAcqPayment.compAcqAgent1Pct = event.value;
    }
    if(fieldName === "acqagent1splitpct"){
      this.employeeAcqPayment.compAcqAgent1SplitPct = event.value;
    }
    if(fieldName === "acqagent2pct"){
      this.employeeAcqPayment.compAcqAgent2Pct = event.value;
    }
    if(fieldName === "acqagent2splitpct"){
      this.employeeAcqPayment.compAcqAgent2SplitPct = event.value;
    }

    if(fieldName === "retagent1pct"){
      this.employeeAcqPayment.compRetAgent1Pct = event.value;
    }
    if(fieldName === "retagent1splitpct"){
      this.employeeAcqPayment.compRetAgent1SplitPct = event.value;
    }
    if(fieldName === "acqagent2pct"){
      this.employeeAcqPayment.compRetAgent2Pct = event.value;
    }
    if(fieldName === "acqagent2splitpct"){
      this.employeeAcqPayment.compRetAgent2SplitPct = event.value;
    }

    this.AcqAgent1PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null ? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null ? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compAcqAgent1Pct != null ? this.employeeAcqPayment?.compAcqAgent1Pct : 0) * (this.employeeAcqPayment?.compAcqAgent1SplitPct != null ? this.employeeAcqPayment?.compAcqAgent1SplitPct : 0);
    this.AcqAgent2PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null ? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null ? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compAcqAgent2Pct != null ? this.employeeAcqPayment?.compAcqAgent2Pct : 0) * (this.employeeAcqPayment?.compAcqAgent2SplitPct != null ? this.employeeAcqPayment?.compAcqAgent2SplitPct : 0);
    this.RetAgent1PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null ? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null ? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compRetAgent1Pct != null ? this.employeeAcqPayment?.compRetAgent1Pct : 0) * (this.employeeAcqPayment?.compRetAgent1SplitPct != null ? this.employeeAcqPayment?.compRetAgent1SplitPct : 0);
    this.RetAgent2PaymentAmt = (this.employeeAcqPayment?.estGrossRev != null? this.employeeAcqPayment?.estGrossRev : 0) * (this.propertyProfile?.mgmtCommPct != null? this.propertyProfile?.mgmtCommPct : 0) * (this.employeeAcqPayment?.compRetAgent2Pct != null? this.employeeAcqPayment?.compRetAgent2Pct : 0) * (this.employeeAcqPayment?.compRetAgent2SplitPct != null? this.employeeAcqPayment?.compRetAgent2SplitPct : 0);
    
    this.form1.patchValue({
      compAcqAgent1Amt: this.AcqAgent1PaymentAmt,
      compAcqAgent2Amt: this.AcqAgent2PaymentAmt,
      compRetAgent1Amt: this.RetAgent1PaymentAmt,
      compRetAgent2Amt: this.RetAgent2PaymentAmt,
      compRetAgent1PayDate1Amount: this.RetAgent1PaymentAmt,
      compRetAgent2PayDate1Amount: this.RetAgent2PaymentAmt,
    });
  }

  /*********
   * Add New Button
   *
   */
  createEmployeeProfile() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add Employee Profile",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(EmployeeProfileComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      // this.addEmployeeProfileCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

}
